import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'yo-preparation-conditionnement',
    templateUrl: './preparation-conditionnement.component.html',
    styleUrls: ['./preparation-conditionnement.component.scss'],
    standalone: false
})
export class PreparationConditionnementComponent implements OnInit {

  ngOnInit(): void {
  }

}
